import { Title } from '@angular/platform-browser';
import { Component, OnDestroy, OnInit, Input } from '@angular/core';


@Component({
  selector: 'sales-report-details',
  templateUrl: './sales.report.details.component.html',
  styleUrls: ['./sales.report.details.component.css']
})
export class SalesReportDetailsComponent implements OnInit {


  IsBusy: boolean = false;

  isEditedTest: boolean = false;

  @Input() SalesData: any[];

  ngOnInit() {
    // this.Init()
  }


}
